@if (show()) {
  <div class="app-update-banner" role="status">
    <p class="omm-paragraph-1-semibold">
      {{
        (downloading()
          ? 'core.appUpdate.downloading'
          : 'core.appUpdate.message'
        ) | transloco
      }}
    </p>
    <button
      type="button"
      class="omm-paragraph-1-semibold"
      [disabled]="busy()"
      [attr.aria-busy]="busy()"
      (click)="apply()"
    >
      @if (busy()) {
        <span class="app-update-spinner" aria-hidden="true"></span>
      }
      {{
        (ready() || busy() ? 'core.appUpdate.apply' : 'core.appUpdate.reload')
          | transloco
      }}
    </button>
  </div>
}
